import { getEventiumUnlockLevelThreshold } from "@/event";
import type { FrameName } from "@/game/entities/config";
import { tilerepoBuildingsFrameNames } from "@/game/entities/config";
import { getBuildingConfig } from "@/game/entities/config/buildings";
import { ResourceType } from "@/game/entities/config/resources";
import type { ResourcesStoreGetters } from "@/store/useResourcesStore";
import { resourceTypeToCurrencyType } from "@/utils/formatPrice";

export const getUnlocksByLevel = (): Partial<Record<ResourceType, number>> => {
	// TODO: Cachuj to more !!!
	return (Array.from(tilerepoBuildingsFrameNames) as Array<FrameName>).reduce(
		(
			acc: Partial<Record<ResourceType, number>>,
			frameName: FrameName,
		): Partial<Record<ResourceType, number>> => {
			const { requirements, production } = getBuildingConfig(frameName);
			const level = requirements.has(ResourceType.LEVEL)
				? requirements.get(ResourceType.LEVEL)
				: 1;
			Array.from(production.keys()).forEach((key: ResourceType): void => {
				const currencyKey = resourceTypeToCurrencyType(key);
				if (!acc[currencyKey] || acc[currencyKey] > level!)
					acc[currencyKey] = level!;
			});

			// 1. The first MAIN row is always unlocked.
			acc[ResourceType.COINS] = 1;
			acc[ResourceType.FOOD_DIFF] = 1;
			acc[ResourceType.POPULATION_DIFF] = 1;
			acc[ResourceType.GEMS] = 1;
			acc[ResourceType.EVENTIUM] = getEventiumUnlockLevelThreshold();

			return acc;
		},
		{} as Partial<Record<ResourceType, number>>,
	);
};

// TODO: remove
export const getCurrencyValue = (
	currency: ResourceType,
	resources: ResourcesStoreGetters,
): number => {
	switch (currency) {
		case ResourceType.FOOD_DIFF:
			return resources.foodDiff.value;
		case ResourceType.POPULATION_DIFF:
			return resources.populationDiff.value;
		case ResourceType.COINS:
			return resources.coins.value;
		case ResourceType.GEMS:
			return resources.gems.value;
		case ResourceType.LUMBER:
			return resources.lumber.value;
		case ResourceType.CLAY:
			return resources.clay.value;
		case ResourceType.STONE:
			return resources.stone.value;
		case ResourceType.GOODS:
			return resources.goods.value;
		case ResourceType.IRON:
			return resources.iron.value;
		case ResourceType.STEEL:
			return resources.steel.value;
		case ResourceType.ARMY:
			return resources.army.value;
		default:
			return 0;
	}
};
